import { TAppNotificationParams } from '@src/providers/App';
import { NOTIFICATION_ERROR_DATA, TSessionNotificationType } from '@src/consts/notifications';

const SESSION_NOTIFICATION_NAME = '_cen_ntf';

/** Пока используется для передачи нотификаций между рендерами */
class SessionStorageClient {
  constructor() {}

  isHasSession() {
    return typeof window !== undefined;
  }

  getNotification() {
    if (!this.isHasSession()) return null;

    const ntfString = sessionStorage.getItem(SESSION_NOTIFICATION_NAME);
    if (ntfString) {
      sessionStorage.removeItem(SESSION_NOTIFICATION_NAME);
      return JSON.parse(ntfString) as TAppNotificationParams;
    } else return null;
  }

  setNotification({
    data,
    params = '',
  }: { data?: TAppNotificationParams | TSessionNotificationType; params?: string } = {}) {
    if (!this.isHasSession()) return;
    let ntf: TAppNotificationParams | null = null;

    if (typeof data === 'object') {
      ntf = data;
    } else if (typeof data === 'string') {
      const ntfFn = NOTIFICATION_ERROR_DATA[data] || NOTIFICATION_ERROR_DATA.COMMON_ERROR;
      ntf = ntfFn(params);
    } else {
      ntf = NOTIFICATION_ERROR_DATA.COMMON_ERROR();
    }

    if (ntf) {
      sessionStorage.setItem(SESSION_NOTIFICATION_NAME, JSON.stringify(ntf));
    }
  }
}

export const SESSION_CLIENT = new SessionStorageClient();
